import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaGraduationCap, FaArrowRight } from "react-icons/fa";
import "../../styles/MentorShip.css";

const JoinMentorship = () => {
  return (
    <section className="begin-section">
      <Container>
        <h2 className="wise-secondary-gradient begin-title ">
          YOUR PLACE TO BEGIN
        </h2>

        <p className="text-secondary begin-description">
          Whether you're seeking guidance or ready to give it, the WiSE
          Mentorship Pillar is your place to begin. Join us as a mentee to gain
          clarity, confidence, and direction—or step in as a mentor to shape
          journeys, share wisdom, and create lasting impact.
          <br />
          Together, we are building a stronger, more inclusive semiconductor
          ecosystem.
        </p>

        <Row className="mt-5">
          {/* Mentee */}
          <Col md={6} className="mb-4">
            <div className="begin-card hover-effect-only wise-gradient-border">
              <div className="wise-icon wise-icon-primary">
                <FaGraduationCap />
              </div>

              <h3 className="text-secondary">Express Your Interest</h3>

              <p className="text-secondary">
                Gain clarity, confidence and direction from experienced
                professionals in the semiconductor industry.
              </p>

              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLScdbZ-skF-AdONWeoRg3YTgsZfbCdWgQio8P0NRurLiLYe9Sw/viewform?usp=publish-editor"
                target="_blank"
                rel="noopener noreferrer"
                className="mentor-card-link"
              >
                Express Your Interests <FaArrowRight />
              </a>
            </div>
          </Col>

          {/* Mentor */}
          <Col md={6} className="mb-4 mx-auto">
            <div className="begin-card hover-effect-only wise-gradient-border">
              <div className="wise-icon wise-icon-primary">
                <FaGraduationCap />
              </div>

              <h3 className="text-secondary">Step In as a Mentor</h3>

              <p className="text-secondary">
                Shape journeys, share wisdom, and create lasting impact in the
                lives of aspiring professionals.
              </p>

              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSeCALf9uAS2p8H1K4O8SWi9dvQoPcQYJTn3_bcbPo8lIi2e-w/viewform?usp=publish-editor"
                target="_blank"
                rel="noopener noreferrer"
                className="mentor-card-link"
              >
                Become a Mentor <FaArrowRight />
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default JoinMentorship;
